import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Trans } from 'lingui-react';

import { Text } from 'base-components';
import { Container, Row, Column } from 'styled-components-reactive-grid';

import EmptyCell from '../EmptyCell';
import HeaderCell from '../HeaderCell';
import { COLUMN_NAMES } from '../constants';
import { buildBaseColumnConfig } from '../utils';

function CaseCustomerCell({ name, customerName, storeCustomerName }) {
  // We alias the customer's name to different props in the query
  // because name is only required for some customer types.
  // Without the alias Apollo gets a bit confused.
  const finalName = name || customerName || storeCustomerName;

  if (!finalName) {
    return <EmptyCell />;
  }

  return (
    <Container modifiers="padScaleY_2">
      <Row>
        <Column modifiers={['col', 'padScaleY_0']}>
          <Text>{finalName}</Text>
        </Column>
      </Row>
    </Container>
  );
}

CaseCustomerCell.propTypes = {
  name: PropTypes.string,
  customerName: PropTypes.string,
  storeCustomerName: PropTypes.string,
};

CaseCustomerCell.defaultProps = {
  name: undefined,
  customerName: undefined,
  storeCustomerName: undefined,
};

export default (...args) => ({
  ...buildBaseColumnConfig(COLUMN_NAMES.customer, ...args),
  cellDataGetter: data => get(data, 'node.customer') || {},
  headerCellRenderer: props => (
    <HeaderCell {...props} label={<Trans>Fleet</Trans>} />
  ),
  dataCellRenderer: CaseCustomerCell,
});



// WEBPACK FOOTER //
// ./src/compositions/CasesDataTable/columns/customer.js